import { createVanIconComponent } from "./van"

const NewspaperOutlined = createVanIconComponent("newspaper-o")
export default NewspaperOutlined
